import { render, staticRenderFns } from "./test-wizard.vue?vue&type=template&id=53357f86&lang=html&"
import script from "./test-wizard.vue?vue&type=script&lang=js&"
export * from "./test-wizard.vue?vue&type=script&lang=js&"
import style0 from "./test-wizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports